import _ from "lodash";
import React from "react";

import ScrollableView from "./ScrollableView";

/* eslint-disable react/prop-types */

const DEFAULT_PRERENDER_MARGIN = 2000;

const defaultScrollableOptions = () => {
  return {
    scrollHorizontally: true,
    scrollVertically: true,
    showHorizontalScrollbar: true,
    showVerticalScrollbar: true,
    horizontalIsInfinite: false,
    verticalIsInfinite: false,
    allowPinchZoom: false,
    invertZoom: false,
    allowCtrlScrollZoom: false,
    disableCtrlScroll: false,
    preRenderMargin: DEFAULT_PRERENDER_MARGIN
  };
};

// This function takes a component...
function withScrollableView(Component, options) {
  // ...and returns another component...
  return function ScrollableViewComponent(props) {
    // ... and renders the wrapped component inside a ScrollableView
    // Notice that we pass through any additional props as well

    let allOptions = _.assign(defaultScrollableOptions(), options);
    return (
      <ScrollableView
        initialZoom={props.initialZoom}
        initialScrollLeft={props.initialScrollLeft}
        initialScrollTop={props.initialScrollTop}
        requestViewBoundsForZoom={props.requestViewBoundsForZoom}
        onScrollChange={props.onScrollChange}
        {...allOptions}
      >
        <Component {...props} />
      </ScrollableView>
    );
  };
}

export default withScrollableView;
